<template>
    <div id="bene-list-container">
        <f7-searchbar search-container=".beneficiary-list-2" search-in=".item-title" :placeholder="$t('beneficiary-search-recipient')" id="bene-search-bar"></f7-searchbar>

        <f7-list class="searchbar-not-found">
            <f7-list-item :title="$t('beneficiary-no-found')"></f7-list-item>
        </f7-list>

        <transition name="fade">
            <f7-card
                :title  ="alertCard.title"
                class   ="alert alert-success mt-md"
                v-show  ="alertCard.show"
            >
                <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
            </f7-card>
        </transition>

        <f7-list no-hairlines class="beneficiary-list-2 searchbar-found no-outlines">
            <f7-list-item v-for="bene in beneficiaryList" :key="bene.beneficiaryId" v-show="isDisplay(bene.homeCountryId)" @click="handleSelectBeneficiary(bene.beneficiaryId)" class="list-content-row">
                <div class="row no-gap w-100">
                    <div class="col-bank"><img :src="getBankImg(bene.bankId)" /></div>
                    <div class="col-details editable">
                        <div class="item-title">{{(bene.beneficiaryAlias == '' || bene.beneficiaryAlias == null) ? bene.firstName : bene.beneficiaryAlias}}</div>
                        <div class="wandr-caption-2" v-if="bene.deliveryMethodId == 1 || bene.deliveryMethodId == 6 || bene.deliveryMethodId == 9">{{bene.bank}}&nbsp;&colon;&nbsp;{{bene.bankAccountNo}}</div>
                        <div class="wandr-caption-2" v-if="bene.deliveryMethodId == 3">{{bene.collectionAgent}}</div>
                        <div class="wandr-caption-2" v-if="bene.deliveryMethodId == 4">{{bene.address.province}}&nbsp;&colon;&nbsp;{{bene.address.city}}</div>
                        <div class="wandr-caption-2" v-if="bene.deliveryMethodId == 0">{{bene.billingOrg}}&nbsp;&colon;&nbsp;{{bene.bankAccountNo}}</div>
                    </div>
                    <div class="col-country">
                        <img class="elevation-2" :src="getFlagImg(bene.homeCountryId)" />
                    </div>
                    <div class="col-edit" v-show="isCreateBene">
                        <img :src="require('@/assets/img/icon/icon-pencil.svg')">
                    </div>
                </div>
            </f7-list-item>
        </f7-list>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";

    export default {
        props: {
            isSearchBar:{
                required: true
            },
            isCreateTrx:{
                required: false
            },
            isCreateBene:{
                required: false
            }
        },
        mounted() {
            if(!this.isSearchBar) {
                let $$ = this.Dom7;
                $$("#bene-search-bar").addClass("hidden-by-searchbar")
            }

            // this.init();
            this.showAlert(false);
            this.loadBeneficiaryList()
        },
        data: function() {
            return {
                beneficiaryList : [],
                routerTo : ""
            }
        },
        computed: {
            ...mapGetters('beneficiary', [
                'alertCard',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setIsCreateBeneficiary'
            ]),

            loadBeneficiaryList() {
                const self = this;
                self.showPreloader();
                const benePromise = this.$api.beneficiary.getBeneficiaryList()

                benePromise.then(function(result) {
                    if(result.length == 0) {
                        self.setIsCreateBeneficiary(true);
                        self.$store.state.beneficiary.routerTo = ( self.$store.state.beneficiary.routerTo == "fxcalculator" ) ? 'emptyListFxCalc' : 'emptyList';
                        self.$f7router.navigate("/beneficiary-new-details");
                    } else {
                        self.populateBeneficiaryListFilter(result)

                        if(self.$store.state.beneficiary.routerTo == "beneficiaryCreated") {
                        // self.openToastBottom();
                        self.showAlert(true, self.$t('beneficiary-created'));
                        } else if(self.$store.state.beneficiary.routerTo == "beneficiaryModified") {
                        // self.openToastBottom();
                        self.showAlert(true, self.$t('beneficiary-modified'));
                        } else if(self.$store.state.beneficiary.routerTo == "beneficiaryDeleted") {
                        // self.openToastBottom();
                        self.showAlert(true, self.$t('beneficiary-removed'));
                        }
                    }
                    self.hidePreloader();
                });
            },

            populateBeneficiaryListFilter(beneList) {
                const self = this
                self.beneficiaryList = []
                if( self.$store.state.beneficiary.routerTo == "fxcalculator" ) {
                    this.routerTo = this.$store.state.beneficiary.routerTo
                    for(let i=0; i < beneList.length; i++) {
                        let beneDMId = beneList[i].deliveryMethodId
                        if(beneList[i].deliveryMethodId == 1 && beneList[i].bankTypeId == 1) { // PHIL GOV SERVICES
                            beneDMId = 8
                        } else if(beneList[i].deliveryMethodId == 1 && beneList[i].bankTypeId == 2) { // WALLET
                            beneDMId = 7
                        }

                        if(self.$store.state.transaction.homeCountryId == beneList[i].homeCountryId && self.$store.state.transaction.deliveryMethodId == beneDMId ) {
                            self.beneficiaryList.push(beneList[i])
                        }
                    }

                    if(self.beneficiaryList.length == 0) {
                        self.setIsCreateBeneficiary(true);
                        self.$store.state.beneficiary.routerTo = 'emptyListFxCalc';
                        self.$f7router.navigate("/beneficiary-new-details");
                    }

                } else {
                    self.beneficiaryList = beneList
                }
            },

            init() {
                const self    = this;
                let toastText = "";

                if(self.$store.state.beneficiary.routerTo == "beneficiaryCreated") {
                    toastText = this.$t('beneficiary-created')
                } else if(self.$store.state.beneficiary.routerTo == "beneficiaryModified") {
                    toastText = this.$t('beneficiary-modified')
                } else if(self.$store.state.beneficiary.routerTo == "beneficiaryDeleted") {
                    toastText = this.$t('beneficiary-removed')
                }

                self.f7Method = {
                    toastBottom: this.$f7.toast.create({
                        text        : toastText,
                        closeTimeout: 2000,
                    })
                }
            },

            openToastBottom() {
                this.f7Method.toastBottom.open();
            },

            showAlert(status, title, content) {
                this.alertCard.show = status;
                if(title == undefined) {
                    title = "";
                } else {
                    title = this.$t(title);
                }

                if(content == undefined) {
                    content = "";
                } else {
                    content = this.$t(content);
                }
                this.alertCard.title   = title;
                this.alertCard.content = content;

                setTimeout(() => {
                    this.alertCard.show = false
                }, 5000)
            },

            handleSelectBeneficiary(id) {
                this.showPreloader();
                var beneficiaryDetails = this.beneficiaryList.filter(bene => bene.beneficiaryId == id);

                var beneficiaryData                   = this.$store.state.beneficiary
                beneficiaryData.statusId              = beneficiaryDetails[0].statusId
                if(this.isCreateBene) {
                    beneficiaryData.beneficiaryId       = id;
                    beneficiaryData.homeCountryId       = beneficiaryDetails[0].homeCountryId
                    beneficiaryData.transactionTypeId   = beneficiaryDetails[0].transactionTypeId
                    beneficiaryData.deliveryMethodId    = beneficiaryDetails[0].deliveryMethodId
                    beneficiaryData.bankId              = beneficiaryDetails[0].bankId
                    beneficiaryData.bankTypeId          = beneficiaryDetails[0].bankTypeId
                    beneficiaryData.collectionAgentId   = beneficiaryDetails[0].collectionAgentId
                    beneficiaryData.beneficiaryTypeId   = beneficiaryDetails[0].beneficiaryTypeId
                    beneficiaryData.paymentPurposeId    = beneficiaryDetails[0].paymentPurposeId
                    beneficiaryData.isCreateBeneficiary = false
                    beneficiaryData.routerTo            = (this.$store.state.beneficiary.routerTo == "fxcalculator") ? 'fxcalculator' : ''
					beneficiaryData.showFormInput.root.walletNo = false
                    beneficiaryData.showFormInput.root.bankAccountNo = false
					this.$f7router.navigate("/beneficiary-modify");
                } else if(this.isCreateTrx) {
                    var transactionData                  = this.$store.state.transaction
                    transactionData.beneficiaryId        = id
                    transactionData.beneficiaryFirstName = beneficiaryDetails[0].firstName
                    transactionData.beneficiaryAlias     = beneficiaryDetails[0].beneficiaryAlias
                    transactionData.beneficiaryFullName  = beneficiaryDetails[0].fullName
                    transactionData.p2hCustomerId        = beneficiaryDetails[0].p2hCustomerId
                    transactionData.bankAccountNo        = beneficiaryDetails[0].bankAccountNo
                    transactionData.bankId               = beneficiaryDetails[0].bankId
                    transactionData.bankBranchId         = beneficiaryDetails[0].bankBranchId
                    transactionData.bankName             = beneficiaryDetails[0].bank
                    transactionData.email                = beneficiaryDetails[0].email
                    transactionData.homeCountryId        = beneficiaryDetails[0].homeCountryId
                    transactionData.homeCountryName      = beneficiaryDetails[0].address.country
                    transactionData.homeCurrency         = beneficiaryDetails[0].homeCurrency
                    transactionData.hostCountryId        = beneficiaryDetails[0].originatingCountryId
                    transactionData.hostCountryName      = beneficiaryDetails[0].originatingCountry
                    transactionData.hostCurrency         = beneficiaryDetails[0].hostCurrency
                    transactionData.collectionAgentId    = beneficiaryDetails[0].collectionAgentId
                    transactionData.collectionAgent      = beneficiaryDetails[0].collectionAgent
                    transactionData.transactionTypeId    = beneficiaryDetails[0].transactionTypeId
                    transactionData.transactionType      = beneficiaryDetails[0].transactionType
                    transactionData.billerCode           = beneficiaryDetails[0].billerCode
                    transactionData.billingOrg           = beneficiaryDetails[0].billingOrg
                    transactionData.latestState          = ""
                    transactionData.provinceId           = beneficiaryDetails[0].address.provinceId
                    transactionData.province             = beneficiaryDetails[0].address.province
                    transactionData.cityId               = beneficiaryDetails[0].address.cityId
                    transactionData.city                 = beneficiaryDetails[0].address.city
                    transactionData.couponCode           = "";
                    transactionData.isQuickSend          = false;
                    transactionData.isMakePayment        = false;
                    transactionData.bankTypeId           = beneficiaryDetails[0].bankTypeId
                    transactionData.serviceId            = beneficiaryDetails[0].serviceId
                    transactionData.paymentPurpose       = beneficiaryDetails[0].paymentPurpose
                    transactionData.paymentPurposeId     = beneficiaryDetails[0].paymentPurposeId
                    transactionData.commissionAmount     = 0
                    transactionData.discountAmount       = 0
                    transactionData.deliveryMethodId     = beneficiaryDetails[0].deliveryMethodId
                    transactionData.deliveryMethodName   = beneficiaryDetails[0].deliveryMethod
                    if(this.$store.state.beneficiary.routerTo != "fxcalculator") {
                        transactionData.hostAmount       = ""
                        transactionData.homeAmount       = ""
                        transactionData.hostAmountReal   = 0
                        transactionData.homeAmountReal   = 0
                        transactionData.paymentMethodId  = 0
                        transactionData.paymentMethod    = ""
                    } else {
                        this.$store.state.beneficiary.routerTo = "fxcalculator"
                    }

                    // IS PHILGOV ?
                    if(transactionData.bankId == 4520 || transactionData.bankId == 4521 || transactionData.bankId == 4522 ) {

                        var currentDate = new Date()
                        transactionData.endMonth       = currentDate.getMonth()
                        transactionData.endYear        = null
                        transactionData.flexiFund      = null
                        transactionData.loanNumber     = ''
                        transactionData.mp2            = ''
                        transactionData.prn            = ''
                        transactionData.startMonth     = currentDate.getMonth()
                        transactionData.startYear      = null
                        transactionData.monthlyAmount  = null
                        transactionData.homeAmountReal = null
                        transactionData.bankBranchId   = 0

                        this.$f7router.navigate("/sendmoney/choose-transaction-type")
                    } else {
                        this.$f7router.navigate("/sendmoney/enter-amount")
                    }
                }
                this.hidePreloader()
            },
        }
    }
</script>